import moment from 'moment';

const PROPERTY_TYPE_LABELS: Record<string, string> = {
  HOUSE: 'Maison',
  APPARTMENT: 'Appartement',
};

const AMOUNT_FORMAT = new Intl.NumberFormat('fr-FR', {
  maximumFractionDigits: 0,
});

export function propertyTypeLabel(type: string): string | undefined {
  return PROPERTY_TYPE_LABELS[type];
}

export function formatAmount(value: number): string | undefined {
  return value == null ? undefined : AMOUNT_FORMAT.format(value);
}

/** Le back envoie la date au format français, puis en ISO après un recalcul. */
function loanStartMoment(value: string): moment.Moment | null {
  if (!value) return null;
  const date = moment(value, ['DD/MM/YYYY', moment.ISO_8601], true);
  return date.isValid() ? date : null;
}

export function parseLoanStartDate(value: string): Date | null {
  return loanStartMoment(value)?.toDate() ?? null;
}

export function formatLoanStartDate(value: string): string | undefined {
  return loanStartMoment(value)?.format('DD/MM/YYYY');
}

export function formatLoanDuration(months: number): string | undefined {
  if (months == null) return undefined;
  const years = Math.floor(months / 12);
  const rest = months % 12;
  const yearLabel = `${years} an${years > 1 ? 's' : ''}`;
  if (!years) return `${rest} mois`;
  return rest ? `${yearLabel} ${rest} mois` : yearLabel;
}

/** Durée du prêt en mois ; une préconisation calculée avant l'ajout des mois n'a que des années. */
export function loanDurationInMonths(parameters: any): number | null {
  if (parameters?.loanDurationInMonths != null) {
    return parameters.loanDurationInMonths;
  }
  return parameters?.loanDuration != null ? parameters.loanDuration * 12 : null;
}
